import Ajax from './base'
import constants from '../constants'

const CGM_ONBOARDING_LANDING_SLUGS = {
  [constants.CGM_TYPE.DIASENS]: constants.CGM_TYPE.DIASENS,
  [constants.CGM_TYPE.GOODFLIP]: constants.CGM_TYPE.GOODFLIP,
  [constants.CGM_TYPE.GLUCOLIVE]: constants.CGM_TYPE.GLUCOLIVE,
}

const resolveCgmOnboardingLandingSlug = (programType) => {
  if (programType && CGM_ONBOARDING_LANDING_SLUGS[programType]) {
    return CGM_ONBOARDING_LANDING_SLUGS[programType]
  }
  if (
    typeof programType === 'string' &&
    ['diasens', 'goodflip', 'glucolive'].includes(programType)
  ) {
    return programType
  }
  return constants.CGM_TYPE.DIASENS
}

const Cgm = {
  getCgmOnboardingLandingPage: (payload) => {
    const programType = resolveCgmOnboardingLandingSlug(payload?.programType)
    const route = `/v8/get_cgm_onboarding_landing_page/${programType}`
    return Ajax.request(route, {
      method: Ajax.GET,
      priv: true,
    })
  },

  setCgmDeviceName: (payload) => {
    const route = '/v8/cgm/device_name'
    return Ajax.request(route, {
      method: Ajax.POST,
      priv: true,
      payload,
    })
  },
}

export default Cgm
